import 'vue';
import './helpers.mjs';
import './config.mjs';
import { b as registerComponent } from './plugins-6d013f3f.mjs';
import './Icon-3973158b.mjs';
import './FormElementMixin-f660a77c.mjs';
import './Input-45fe236f.mjs';
import './MatchMediaMixin-cd993bd3.mjs';
import './trapFocus-dc03669f.mjs';
import './DropdownItem-f99239fa.mjs';
import './Field-ba437ae1.mjs';
import './Select-93c80bbb.mjs';
import { s as script } from './Datepicker-605ce9b4.mjs';
export { s as ODatepicker } from './Datepicker-605ce9b4.mjs';

var index = {
    install(app) {
        registerComponent(app, script);
    }
};

export default index;
